import { useNavigate } from 'react-router';
import { Points } from 'components/Points/Points';
import MagicButton from 'components/MagicButton/MagicButton';
import { AssetUrls } from 'config/assets';
import './HoverOverlay.css';

interface HoverOverlayProps {
  title: string;
  cardId: string | number;
  oracleId?: string;
  setName?: string;
  setCode?: string;
  setIconUrl?: string;
  nonFoilPrice?: number;
  foilPrice?: number;
  availableInNonFoil?: boolean;
  availableInFoil?: boolean;
  onClose?: () => void;
  isMobile?: boolean;
}

const HoverOverlay = ({
  title,
  cardId,
  oracleId,
  setName,
  setCode,
  setIconUrl,
  nonFoilPrice,
  foilPrice,
  availableInNonFoil,
  availableInFoil,
  onClose,
  isMobile = false,
}: HoverOverlayProps) => {
  const navigate = useNavigate();

  const handleCardNavigation = () => {
    navigate(`/cards/${cardId}`);
  };

  const handleWantClick = () => {
    // Navigate to view-card-printings page with the card name and ID for exact matching
    const encodedName = encodeURIComponent(title);
    navigate(`/view-card-printings/${encodedName}?cardId=${cardId}`);
  };

  // Get the best available price
  const getCurrentPrice = () => {
    // Prefer non-foil price, but show foil if that's all we have
    if (nonFoilPrice !== undefined && nonFoilPrice !== null && nonFoilPrice !== 0) {
      return nonFoilPrice;
    }
    
    if (foilPrice !== undefined && foilPrice !== null && foilPrice !== 0) {
      return foilPrice;
    }
    
    return null;
  };

  return (
    <div className="hover-overlay">
      {/* Mobile close button */}
      {isMobile && onClose && (
        <button className="mobile-close-btn" onClick={onClose} aria-label="Close">
          ×
        </button>
      )}
      
      {/* Card title with inline arrow icon */}
      <div 
        className="hover-title-row"
        onClick={handleCardNavigation}
      >
        <span className="hover-title">{title}</span>
        <img 
          className="hover-arrow-inline"
          src={`${AssetUrls.base}/assets/icons/Search/icon-arrow-diagonal.svg`}
          alt="View details"
        />
      </div>

      {/* Set icon and name */}
      {setName && (
        <div className="hover-set-info">
          {(setIconUrl || setCode) && (
            <img 
              src={setIconUrl || `https://d3dmfym8zvsq5m.cloudfront.net/sets/icons/${setCode}.svg`}
              alt={`${setName} set symbol`}
              className="hover-set-icon"
              onError={(e) => {
                e.currentTarget.style.display = 'none';
              }}
            />
          )}
          <span className="hover-set-name">{setName}</span>
        </div>
      )}

      {/* Price section */}
      <div className="hover-price-section">
        {getCurrentPrice() !== null && getCurrentPrice() !== 0 ? (
          <Points type="big" points={getCurrentPrice()!} />
        ) : (
          <div className="price-unavailable">???</div>
        )}
      </div>

      {/* Want button */}
      <div className="hover-action-row">
        <MagicButton
          label="Want"
          icon="heart"
          color="black"
          onPress={handleWantClick}
          fullWidth
        />
      </div>
    </div>
  );
};

export default HoverOverlay;
